<template>
  <transition name="fade-scale">
    <div
      v-if="isVisible"
      id="confirm-modal"
      class="confirmation-modal c-modal-backdrop-wr"
    >
      <div class="c-modal">
        <div
          :class="['window', { 'small': isSmallTitle }, ...classes]"
        >
          <icon-component
            iconName="close"
            class="close-btn"
            @click="close"
          />

          <div
            v-if="title"
            :class="['title', { 'small': isSmallTitle }]"
          >
            {{ title }}
          </div>

          <div class="message">
            {{ message }}
          </div>

          <base-button
            v-if="!isConfirm"
            :text="buttonLabel"
            classes="ok-button def-btn main-action-btn uppercase medium border-2"
            @onClick="_confirm"
          />

          <div
            v-if="isConfirm"
            class="confirm-buttons"
          >
            <base-button
              :text="declineButton"
              classes="ok-button def-btn secondary-action-btn uppercase medium border-2"
              @onClick="close"
            />

            <base-button
              :text="confirmButton"
              classes="ok-button def-btn main-action-btn uppercase medium border-2"
              @onClick="onConfirm"
            />
          </div>
        </div>
      </div>

      <div class="c-modal-backdrop"></div>
    </div>
  </transition>
</template>

<script>
import BaseButton from "@/components/_shared/Button.vue";
import iconComponent from "@/components/_shared/Icon.vue";

export default {
  name: 'ConfirmModal',

  emits: ['onConfirmModalClose', 'onConfirmModalConfirm'],

  components: {
    BaseButton,
    iconComponent
  },
  
  data() {
    return {
      isVisible: false,
      title: '',
      message: '',
      buttonLabel: '',
      isSmallTitle: false,

      onConfirm: null,

      isConfirm: false,
      confirmButton: '',
      declineButton: '',

      classes: [],
    }
  },

  watch: {
    isVisible(res) {
      if (res) {
        document.body.classList.add("modal-open");

        return
      }

      setTimeout(() => {
        document.body.classList.remove("modal-open");
      }, 300);
    },
  },

  beforeUnmount() {
    this.emmiter.emit('toggleModals', {opened: false, type: 'ConfirmModal'});
  },
  
  methods: {
    escListener(e) {
      if (e.code === 'Escape') {
        this.close();
      }
    },

    open() {
      this.isVisible = true;
      this.emmiter.emit('toggleModals', {opened: true, type: 'ConfirmModal'});
      document.addEventListener('keydown', this.escListener);
    },

    close() {
      this.isVisible = false;
      document.removeEventListener('keydown', this.escListener);
      this.emmiter.emit('toggleModals', {opened: false, type: 'ConfirmModal'});
    },

    show({ title, message, buttonLabel, isSmallTitle, isConfirm, confirmButton, declineButton, onConfirm, classes }) {
      this.title = title;
      this.message = message;
      this.buttonLabel = buttonLabel;
      this.isSmallTitle = isSmallTitle ?? false;
      this.isConfirm = isConfirm ?? false;
      this.confirmButton = confirmButton;
      this.declineButton = declineButton;
      this.onConfirm = onConfirm;
      this.classes = classes ?? [];

      this.open();
    },

    _confirm() {
      this.$emit('onConfirmModalConfirm');
      this.close();
    },

    _cancel() {
      this.close();
    },
  },
}
</script>

<style lang="less" scoped>
.fade-scale-enter-active, .fade-scale-leave-active {
  transition: all 0.3s;
  .window {
    transition: all 0.3s;
  }
}
.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  .window {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}

.c-modal-backdrop-wr {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .c-modal {
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    z-index: 1041;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;

    --color-background: #ffffff;
    --color-title: #3F8EC5;
    --color-text: #1C282D;
    --color-backdrop: #000000;

    .window {
      background: var(--color-background);
      border-radius: 8px;
      box-shadow: 4px 4px 12px 0 rgba(0, 0, 0, 0.12);
      width: 488px;
      height: auto;
      min-height: 150px;
      margin-left: auto;
      margin-right: auto;
      padding: 23px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      flex-wrap: wrap;
      position: relative;
      box-sizing: border-box;

      * > {
        font-family: 'Segoe UI',sans-serif;
        font-style: normal;
      }

      .close-btn {
        position: absolute;
        top: 12px;
        right: 12px;
        cursor: pointer;
      }

      .ok-button {
        width: 100%;
      }

      .title {
        font-weight: 300;
        font-size: 42px;
        line-height: 56px;

        color: var(--color-title);

        &.small {
          font-size: 32px;
          line-height: 42px;
        }
      }

      .message {
        font-weight: 400;
        font-size: 16px;
        line-height: 21px;
        letter-spacing: -0.3px;
        padding: 24px 0;

        color: var(--color-text);
      }

      .timer {
        font-weight: 600;
        font-size: 28px;
        line-height: 37px;
        text-align: center;

        padding-bottom: 40px;

        letter-spacing: -0.4px;

        color: var(--color-title);
      }
    }

    .confirm-buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      width: 100%;

      button {
        width: 100%;
      }
    }
  }

  .c-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: var(--color-backdrop);
    opacity: 0;
  }
}
</style>
